import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { NPIDataGridColDef } from 'src/components/NPIDataGrid/NPIDataGrid';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import { formatDate } from 'src/utils/utils';

const CheckInCallHistoryColumnDef = () => {
    const columns: NPIDataGridColDef[] = [
        {
            field: 'id',
            headerName: 'Call ID',
        },
        {
            field: 'createdAt',
            headerName: 'Date/Time',
            renderCell: (params: GridRenderCellParams) => {
                return <>{params.value && formatDate({ date: params.value })}</>;
            },
        },
        {
            field: 'subject',
            headerName: 'Subject',
        },
        {
            field: 'fullName',
            headerName: 'Added By',
        },
    ];

    return columns.map((column: NPIDataGridColDef) => {
        return createColumnDef(column);
    });
};

export default CheckInCallHistoryColumnDef;
